import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth APIs
export const authAPI = {
  sendOTP: (phone) => api.post('/auth/send-otp', { phone }),
  verifyOTP: (phone, otp) => api.post('/auth/verify-otp', { phone, otp }),
  register: (phone, name, role) => api.post('/auth/register', { phone, name, role }),
  getUser: (userId) => api.get(`/users/${userId}`),
};

// Ride APIs
export const rideAPI = {
  create: (rideData, customerId) => api.post(`/rides?customer_id=${customerId}`, rideData),
  getAll: () => api.get('/rides'),
  getByCustomer: (customerId) => api.get(`/rides/customer/${customerId}`),
  getByDriver: (driverId) => api.get(`/rides/driver/${driverId}`),
  getById: (rideId) => api.get(`/rides/${rideId}`),
  assign: (rideId, driverId, vehicleId, fareEstimate) => 
    api.put(`/rides/${rideId}/assign`, { driver_id: driverId, vehicle_id: vehicleId, fare_estimate: fareEstimate }),
  start: (rideId) => api.put(`/rides/${rideId}/start`),
  end: (rideId) => api.put(`/rides/${rideId}/end`),
  cancel: (rideId) => api.put(`/rides/${rideId}/cancel`),
};

// Vehicle APIs
export const vehicleAPI = {
  create: (vehicleData) => api.post('/vehicles', vehicleData),
  getAll: () => api.get('/vehicles'),
  getAvailable: () => api.get('/vehicles/available'),
  getById: (vehicleId) => api.get(`/vehicles/${vehicleId}`),
  update: (vehicleId, data) => api.put(`/vehicles/${vehicleId}`, data),
  delete: (vehicleId) => api.delete(`/vehicles/${vehicleId}`),
};

// Driver APIs
export const driverAPI = {
  create: (driverData) => api.post('/drivers', driverData),
  getAll: () => api.get('/drivers'),
  getAvailable: () => api.get('/drivers/available'),
  getById: (driverId) => api.get(`/drivers/${driverId}`),
  getByUserId: (userId) => api.get(`/drivers/user/${userId}`),
  update: (driverId, data) => api.put(`/drivers/${driverId}`, data),
  delete: (driverId) => api.delete(`/drivers/${driverId}`),
};

// Carousel APIs
export const carouselAPI = {
  getAll: () => api.get('/carousel'),
  create: (imageData, uploadedBy) => api.post(`/carousel?uploaded_by=${uploadedBy}`, imageData),
  delete: (imageId) => api.delete(`/carousel/${imageId}`),
};

// Traffic Updates APIs
export const trafficAPI = {
  get: () => api.get('/traffic-updates'),
  create: (message, updatedBy) => api.post(`/traffic-updates?updated_by=${updatedBy}`, { message, is_active: true }),
  update: (updateId, message, isActive) => api.put(`/traffic-updates/${updateId}`, { message, is_active: isActive }),
  delete: (updateId) => api.delete(`/traffic-updates/${updateId}`),
};

// Notification APIs
export const notificationAPI = {
  getByUser: (userId) => api.get(`/notifications/${userId}`),
  getUnreadCount: (userId) => api.get(`/notifications/${userId}/unread/count`),
  markRead: (notificationId) => api.put(`/notifications/${notificationId}/read`),
  markAllRead: (userId) => api.put(`/notifications/${userId}/read-all`),
};

// Stats APIs
export const statsAPI = {
  getDashboard: () => api.get('/stats/dashboard'),
};

export default api;
